import { Box, Flex } from '@chakra-ui/react';
import React from 'react';

import useIsMobile from 'lib/hooks/useIsMobile';

const VERTICAL_LINES = 9;
const VERTICAL_LINES_MOBILE = 3;
const LINE_COLOR = 'rgba(203, 227, 212, 10%)';
const FIRST_LAST_STYLES = {
  opacity: 0,
};

export default function GridBG() {

  const isMobile = useIsMobile();

  return (
    <Box position="absolute" top={ 0 } left={ 0 } bottom={ 0 } right={ 0 }>
      <Box h="1px" w="100%" position="absolute" top="50%" bg={ LINE_COLOR }/>
      <Flex justifyContent="space-between" h="100%">
        { Array.from({ length: (isMobile ? VERTICAL_LINES_MOBILE : VERTICAL_LINES) + 2 }).map((_, i) => (
          <Box
            _first={ FIRST_LAST_STYLES }
            _last={ FIRST_LAST_STYLES }
            key={ i }
            w="1px"
            h="100%"
            bg={ LINE_COLOR }/>
        ),
        ) }
      </Flex>
    </Box>
  );
}
